<template>
  <fragment>
    <!-- End Infobar Setting Sidebar -->
    <div class="row">
      <div class="col-12">
        <div class="card m-b-30">
          <div class="card-header row">
            <div class="col">
              <h5 class="card-title mb-0" >Filtri</h5>
              
            </div>
          </div>
        
          <div class="card-body">
            <div class="row">
              <div class="col">
                <input
                  type="text"
                  v-model="query"
                  class="form-control mb-2"
                  placeholder="Nome, cognome username"
                />
              </div>
            </div>
             

            <div class="row">
              <div class="col text-right">
               
                <div class="btn-group"  >
                <button class="btn btn-primary-rgba mr-2" v-on:click="loaddata">
                  <i class="feather icon-filter mr-2"></i>Ricerca
                </button>
                <button class="btn btn-danger-rgba" v-on:click="resetdata">
                  <i class="feather icon-delete mr-2"></i>Elimina filtro
                </button>
              </div>
            </div>
          </div>
          </div>
        </div>

        <div class="card m-b-30">
          <div class="card-body">
          <router-link class="btn btn-sm btn-primary-rgba"  :to="{name:'route-user-edit', params:{'id':'00000000-0000-0000-0000-000000000000'}}">
                                <i class="feather icon-plus"></i> Nuovo utente
                            </router-link>
                           
            <table

              ref="table"
              id="list-user-table"
              class="table w-100"
            ></table>
          </div>
        </div>
      </div>
    </div>
   
    <!-- /.col -->
  </fragment>
</template>

<script>
export default {
  computed: {},
  components: {},
  data() {
    return {
    
      query: "",
    
    };
  },
  name: "UserList",
  beforeMount() {
    
  },

  mounted() {
    var me = this;
    if (localStorage.getItem("user-list-query"))
      me.query = localStorage.getItem("user-list-query");
  

    setTimeout(this.loaddata, 200);
  },
  methods: {
    edit: function (id) {
      this.$router.push({ name: "route-user-edit", params: { id: id } });
      return false;
    },
    resetdata() {
      this.query = "";
     
      this.loaddata();
    },
    loaddata: function () {
    
      //console.log("usidebar",this.$refs.usidebar.loaddata);
      window["EditAction"] = this.edit;
      var me = this;

      var edit = "M";
      if (me.$refs && me.$refs.edit && me.$refs.edit.outerHTML) {
        edit = me.$refs.edit.outerHTML;
      }

      var remove = "C";
      if (me.$refs && me.$refs.remove && me.$refs.remove.outerHTML) {
        remove = me.$refs.remove.outerHTML;
      }
      if ($.fn.DataTable.isDataTable("#list-user-table")) {
        $("#list-user-table").DataTable().destroy();
      }

      var $table = $("#list-user-table").DataTable({
        searching: false,
        ordering: false,
        processing: true,
        serverSide: true,
        ajax: {
          url: window.SETTINGS.apiUrl + "/user/list",
          type: "POST",
          data: function (d) {
            localStorage.setItem("user-list-query", me.query);
            
            d.search.value = me.query;
            
            d.filters = [
             
            ];
            d.tago;

            return JSON.stringify(d);
          },

          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },

        columns: [
          {
            data: "userId",
            name: "userId",
            title: "Utente",
            render: function (data, type, row, meta) {
              return row.firstName+' '+row.lastName+' ('+ row.username+')';
            },
          },
          {
            className: "text-right",
            data: "userId",
            name: "userId",
            title: "Azioni",
            render: function (data, type, row, meta) {
             
              
              return `<div class="button-list"><button type="button" class="btn btn-success-rgba" data-id="${data}" onClick="window.EditAction('${data}')"><i class="feather icon-edit-2"></i></button>
                                    <button type="button" class="btn btn-danger-rgba remove-action" data-url="user/${data}"  data-id="${data}"><i class="feather icon-trash"></button></div>`;
            },
          },
        ],
      });

   
    },
  },
};
</script>
